import { BsGlobe, BsMegaphone, BsRobot, BsCpu } from "react-icons/bs";

function Hero() {
  return (
    <section id="home" className="hero-section">
      <div className="container">
        <div className="row align-items-center min-vh-100">
          {/* LEFT SIDE */}

          <div className="col-lg-6">
            <span className="hero-badge">
              Websites • Marketing • AI Automation
            </span>

            <h1 className="hero-title">
              Build A Business That Attracts More Customers And Scales Faster
            </h1>

            <p className="hero-description">
              Adyah Consultancy Services helps businesses generate leads,
              improve customer experience and automate operations through
              websites, marketing and AI solutions.
            </p>

            <div className="hero-buttons">
              <a href="#contact" className="btn-primary-custom">
                Get Free Consultation
              </a>

              <a href="#portfolio" className="btn-outline-custom">
                View Portfolio
              </a>
            </div>

            <div className="hero-pills">
              <span>Lead Generation</span>
              <span>SEO Ready</span>
              <span>AI Powered</span>
              <span>Responsive Design</span>
            </div>
          </div>

          {/* RIGHT SIDE */}

          <div className="col-lg-6 mt-5 mt-lg-0">
            <div className="adyah-visual">
              <div className="node top">
                <BsCpu />
                <span>AI Agents</span>
              </div>

              <div className="node left">
                <BsGlobe />
                <span>Websites</span>
              </div>

              <div className="node right">
                <BsMegaphone />
                <span>Marketing</span>
              </div>

              <div className="node bottom">
                <BsRobot />
                <span>Automation</span>
              </div>

              <div className="letter-a">A</div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default Hero;
